/**
 * Utility to add passive event listeners to improve scroll performance
 * This helps prevent the "Added non-passive event listener to a scroll-blocking 'touchstart' event" violation
 */

// Store original addEventListener
const originalAddEventListener = EventTarget.prototype.addEventListener;

// Override addEventListener to make touchstart and touchmove events passive by default
EventTarget.prototype.addEventListener = function (type, listener, options) {
  // Check if it's a touch event and options is not already specified
  if (
    (type === "touchstart" || type === "touchmove") &&
    typeof options !== "object"
  ) {
    // Make the event passive by default
    options = { passive: true };
  } else if (typeof options === "boolean") {
    // If options is a boolean (useCapture), convert to object and add passive
    if (type === "touchstart" || type === "touchmove") {
      options = { capture: options, passive: true };
    }
  } else if (typeof options === "object" && options !== null) {
    // If options is an object, ensure passive is set for touch events
    if (
      (type === "touchstart" || type === "touchmove") &&
      options.passive === undefined
    ) {
      options.passive = true;
    }
  }

  // Call the original addEventListener with modified options
  return originalAddEventListener.call(this, type, listener, options);
};

/**
 * Function to manually add passive event listeners
 * Use this when you need to explicitly add passive listeners
 */
export const addPassiveEventListener = (
  element,
  event,
  handler,
  options = {}
) => {
  const passiveOptions = { ...options, passive: true };
  element.addEventListener(event, handler, passiveOptions);
};

/**
 * Function to add passive touch event listeners to an element
 */
export const addPassiveTouchListeners = (element, handlers) => {
  if (handlers.touchstart) {
    addPassiveEventListener(element, "touchstart", handlers.touchstart);
  }
  if (handlers.touchmove) {
    addPassiveEventListener(element, "touchmove", handlers.touchmove);
  }
  if (handlers.touchend) {
    addPassiveEventListener(element, "touchend", handlers.touchend);
  }
};

export default {
  addPassiveEventListener,
  addPassiveTouchListeners,
};
